import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { useCountryCode } from 'utils/hooks/useCountryCode';
import { useVendorConfig } from '../../store/vendor/useVendorConfig';

export const LegalFooter = () => {
  const { footer } = useVendorConfig();
  const countryCode = useCountryCode();
  const links = footer.links[countryCode] ?? footer.links.default;

  return (
    <Box bottom="0" bg="#ffffff33" py={2}>
      <Flex
        fontSize="xs"
        color="footerColor"
        w="100vw"
        justifyContent="center"
        flexWrap="wrap"
      >
        <Text display="inline-block" whiteSpace="nowrap">
          {footer.legal}
        </Text>
        {links.map((link) => (
          <Box key={link.url}>
            <Link
              href={link.url}
              cursor="pointer"
              target="_blank"
              rel="noreferrer"
              display="inline-block"
              whiteSpace="nowrap"
            >
              <span>&nbsp;&nbsp;-&nbsp;&nbsp;</span>
              {link.title}
            </Link>
          </Box>
        ))}
      </Flex>
    </Box>
  );
};
